/**
 * HeatPumpConfigForm - Heat Pump configuration form.
 */

import { Stack, NumberInput, Select, Checkbox } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import type { ProsumerFormValues } from '../../types';

export interface HeatPumpConfigFormProps {
  form: UseFormReturnType<ProsumerFormValues>;
}

export function HeatPumpConfigForm({ form }: HeatPumpConfigFormProps) {
  return (
    <Stack gap="sm">
      <NumberInput
        label="Powierzchnia domu (m²)"
        min={50}
        max={400}
        step={10}
        value={form.values.heatPumpConfig.houseAreaM2}
        onChange={(val) => form.setFieldValue('heatPumpConfig.houseAreaM2', typeof val === 'number' ? val : 120)}
      />

      <Select
        label="Izolacja"
        data={[
          { value: 'GOOD', label: 'Dobra' },
          { value: 'MODERATE', label: 'Średnia' },
          { value: 'POOR', label: 'Słaba' },
        ]}
        value={form.values.heatPumpConfig.insulationLevel}
        onChange={(val) => val && form.setFieldValue('heatPumpConfig.insulationLevel', val as any)}
      />

      <Select
        label="Typ pompy"
        data={[
          { value: 'AIR_SOURCE', label: 'Powietrzna' },
          { value: 'GROUND_SOURCE', label: 'Gruntowa' },
        ]}
        value={form.values.heatPumpConfig.pumpType}
        onChange={(val) => val && form.setFieldValue('heatPumpConfig.pumpType', val as any)}
      />

      <Checkbox
        label="Obsługuje CWU"
        checked={form.values.heatPumpConfig.includesCWU}
        onChange={(e) => form.setFieldValue('heatPumpConfig.includesCWU', e.currentTarget.checked)}
      />

      <Select
        label="System grzewczy"
        data={[
          { value: 'UNDERFLOOR', label: 'Podłogowe' },
          { value: 'RADIATORS', label: 'Grzejniki' },
        ]}
        value={form.values.heatPumpConfig.heatingSystemType}
        onChange={(val) => val && form.setFieldValue('heatPumpConfig.heatingSystemType', val as any)}
      />
    </Stack>
  );
}
